import mainTheme from "@irati/ui/src/global/theme"
import Pill from "@irati/ui/src/Pill"
import {H2, Label} from "@irati/ui/src/Typography"
import styled, {css} from "styled-components"

export const Content = styled.div<{color?: string}>`
  ${({theme, color = mainTheme.colors.utility.white}) => css`
    h2,
    h5,
    span {
      text-align: left;
      color: ${color || theme.colors.utility.white};
    }
    button span {
      color: ${theme.colors.utility.white};
    }
  `}
`
export const SavingHeader = styled(H2)`
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    img {
      width: 32px;
      height: 32px;
    }
  `}
`

export const OldValueLabel = styled(Label)`
  img {
    width: 16px;
    height: 16px;
  }

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    font-size: 18px
    img {
      width: 24px
      height: 24px
    }
  `}
`

export const Thumbnail = styled.img`
  ${({theme}) => css`
    width: 64px;
    height: 64px;
    object-fit: contain;
    margin-right: ${theme.spacing.two};
    border-radius: ${theme.border.radius.large};
  `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    width: 128px;
    height: 128px;
    margin-right: ${theme.spacing.five};
  `}
`

export const StyledPill = styled(Pill)`
  position: absolute;
  ${({theme}) => css`
    top: ${theme.spacing.two};
    right: ${theme.spacing.two};
  `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    top: ${theme.spacing.four};
    right: ${theme.spacing.five};
  `}
`
